import samePlaceDifferentTime from "./puzzles/samePlaceDifferentTime";
import celebratoryChemistry from "./puzzles/celebratoryChemistry";
import lookingForASpy from "./puzzles/lookingForASpy";
import ancientAccounting from "./puzzles/ancientAccounting";
import theIconsOfStrategy from "./puzzles/theIconsOfStrategy";
import healthyTimeOnTV from "./puzzles/healthyTimeOnTv";
import subtractingToTheOtherSide from "./puzzles/subtractingToTheOtherSide";
import littleYellowRunningThrough from "./puzzles/littleYellowRunningThrough";
import itsAMarvelousWorld from "./puzzles/itsAMarvelousWorld";
import doYouSpeakEnglish from "./puzzles/doYouSpeakEnglish";
import aTravelingIcon from "./puzzles/aTravelingIcon";
import aChunkOfEvil from "./puzzles/aChunkOfEvil";
import aRichManAPoorBoyAndJustATeenager from "./puzzles/aRichManAPoorBoyAndJustATeenager";
import steppingIntoSurreal from "./puzzles/steppingIntoSurreal";
import itsTightInThere from "./puzzles/itsTightInThere";
import noNamesButAllTheCredit from "./puzzles/noNamesButAllTheCredit";
import shapeOfLife from "./puzzles/shapeOfLife";
import theBoundariesOfMystery from "./puzzles/theBoundariesOfMystery";
import aJourneyNeverFinished from "./puzzles/aJourneyNeverFinished";
import dribbleThoseTiles from "./puzzles/dribbleThoseTiles";
import theresASentenceInThere from "./puzzles/theresASentenceInThere";
import cryptograms from "./puzzles/cryptograms";
import actorsYouKnowButCantName from "./puzzles/actorsYouKnowButCantName";
import animalTracksOnTheScreen from "./puzzles/animalTracksOnTheScreen";
import emojiTitles from "./puzzles/emojiTitles";
import aNoteOfAchievement from "./puzzles/aNoteOfAchievement";

export const allPuzzles = [
  samePlaceDifferentTime,
  celebratoryChemistry,
  lookingForASpy,
  ancientAccounting,
  theIconsOfStrategy,
  healthyTimeOnTV,
  subtractingToTheOtherSide,
  littleYellowRunningThrough,
  itsAMarvelousWorld,
  doYouSpeakEnglish,
  aTravelingIcon,
  aChunkOfEvil,
  aRichManAPoorBoyAndJustATeenager,
  steppingIntoSurreal,
  itsTightInThere,
  noNamesButAllTheCredit,
  shapeOfLife,
  theBoundariesOfMystery,
  aJourneyNeverFinished,
  dribbleThoseTiles,
  theresASentenceInThere,
  cryptograms,
  actorsYouKnowButCantName,
  animalTracksOnTheScreen,
  emojiTitles,
  aNoteOfAchievement,
];
